module.exports = __webpack_public_path__ + "img/itmo_small_blue_logo.fa5f8553.png";